import { render, staticRenderFns } from "./radio-list.vue?vue&type=template&id=84b5b92e&scoped=true"
import script from "./radio-list.vue?vue&type=script&lang=js"
export * from "./radio-list.vue?vue&type=script&lang=js"
import style0 from "./radio-list.vue?vue&type=style&index=0&id=84b5b92e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84b5b92e",
  null
  
)

export default component.exports